import { render, staticRenderFns } from "./LoadingCover.vue?vue&type=template&id=67298f8b"
import script from "./LoadingCover.vue?vue&type=script&lang=ts"
export * from "./LoadingCover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports